import * as types from '../mutation-types'
import Vue from 'vue'

const state = {
  visible: {
    login: false,
    whiteboard: false,
    attach: false,
    survey: false,
    videotour: false,
    learnmore: false,
    report: false,
    startproject: false,
    judgeonboard: false,
    judgeApplicationFilter: false,
    judgeTeamContextMenu: false,
    judgeTeamCreationModal: false,
    judgeTeamProjectsAssignModal: false,
    judgeTeamProjectsScheduleModal: false,
    yscPreRegistrationModal: false,
    customQuestionSurvey: false
  },
  data: {}
}

const getters = {
  modalIsVisible: (state) => (key) => {
    return state.visible[key] || false
  },
  modalData: (state) => (key) => {
    return state.data[key] || null
  }
}

// actions
const actions = {
  updateModal ({ commit }, { key, visible, data }) {
    commit(types.SET_MODAL_VISIBILITY, { key, visible })
    commit(types.SET_MODAL_DATA, { key, data })
  },
  showLoginModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'login', visible: true, data })
  },
  hideLoginModal ({ dispatch }) {
    dispatch('updateModal', { key: 'login', visible: false })
  },
  showReportModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'report', visible: true, data })
  },
  hideReportModal ({ dispatch }) {
    dispatch('updateModal', { key: 'report', visible: false })
  },
  showWhiteboardModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'whiteboard', visible: true, data })
  },
  hideWhiteboardModal ({ dispatch }) {
    dispatch('updateModal', { key: 'whiteboard', visible: false })
  },
  showAttachModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'attach', visible: true, data })
  },
  hideAttachModal ({ dispatch }) {
    dispatch('updateModal', { key: 'attach', visible: false })
  },
  showSignupSurvey ({ dispatch }, data) {
    dispatch('updateModal', { key: 'survey', visible: true, data })
  },
  showCustomQuestionSurvey ({ dispatch }, data) {
    dispatch('updateModal', { key: 'customQuestionSurvey', visible: true, data })
  },
  hideCustomQuestionSurvey ({ dispatch }) {
    dispatch('updateModal', { key: 'customQuestionSurvey', visible: false })
  },
  hideSignupSurvey ({ dispatch }) {
    dispatch('updateModal', { key: 'survey', visible: false })
  },
  showVideoTourModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'videotour', visible: true, data })
  },
  hideVideoTourModal ({ dispatch }) {
    dispatch('updateModal', { key: 'videotour', visible: false })
  },
  showLearnMoreModal ({ dispatch }) {
    dispatch('updateModal', { key: 'learnmore', visible: true })
  },
  hideLearnMoreModal ({ dispatch }) {
    dispatch('updateModal', { key: 'learnmore', visible: false })
  },
  showStartProjectModal ({ dispatch }) {
    dispatch('updateModal', { key: 'startproject', visible: true })
  },
  hideStartProjectModal ({ dispatch }) {
    dispatch('updateModal', { key: 'startproject', visible: false })
  },
  showJudgingOnboardingTutorialModal ({ dispatch }) {
    dispatch('updateModal', { key: 'judgeonboard', visible: true })
  },
  hideJudgingOnboardingTutorialModal ({ dispatch }) {
    dispatch('updateModal', { key: 'judgeonboard', visible: false })
  },
  showJudgeApplicationFilerModal ({ dispatch, rootState }) {
    if (rootState.project.judgingQuestionsStatus === 'loaded') {
      dispatch('updateModal', { key: 'judgeApplicationFilter', visible: true })
    }
  },
  hideJudgeApplicationFilerModal ({ dispatch }) {
    dispatch('updateModal', { key: 'judgeApplicationFilter', visible: false })
  },
  showJudgeTeamContextMenu ({ dispatch }, data) {
    dispatch('updateModal', { key: 'judgeTeamContextMenu', visible: true, data })
  },
  hideJudgeTeamContextMenu ({ dispatch }) {
    dispatch('updateModal', { key: 'judgeTeamContextMenu', visible: false })
  },
  showJudgeTeamCreationModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'judgeTeamCreationModal', visible: true, data })
  },
  hideJudgeTeamCreationModal ({ dispatch }) {
    dispatch('updateModal', { key: 'judgeTeamCreationModal', visible: false })
  },
  showJudgeAssignProjectsModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'judgeTeamProjectsAssignModal', visible: true, data })
  },
  hideJudgeAssignProjectsModal ({ dispatch }) {
    dispatch('updateModal', { key: 'judgeTeamProjectsAssignModal', visible: false })
  },
  showJudgeTeamProjectsScheduleModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'judgeTeamProjectsScheduleModal', visible: true, data })
  },
  hideJudgeTeamProjectsScheduleModal ({ dispatch }) {
    dispatch('updateModal', { key: 'judgeTeamProjectsScheduleModal', visible: false })
  },
  showYscPreRegistrationModal ({ dispatch }, data) {
    dispatch('updateModal', { key: 'yscPreRegistrationModal', visible: true, data })
  },
  hideYscPreRegistrationModal ({ dispatch }) {
    dispatch('updateModal', { key: 'yscPreRegistrationModal', visible: false })
  }
}

const mutations = {
  [types.SET_MODAL_VISIBILITY] (state, params) {
    state.visible[params.key] = params.visible
  },
  [types.SET_MODAL_DATA] (state, params) {
    Vue.set(state.data, params.key, params.data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
